import React, { useState } from "react";
import { useEffect } from "react";
// const counters = [
//   { name: "adult", defaultValue: 1 },
//   { name: "child", defaultValue: 0 },
//   { name: "rooms", defaultValue: 1 },
// ];

const Counter = ({ name, defaultValue, onCounterChange, guetsValue,setBookGuest,setGuestValue }) => {

  

  const [count, setCount] = useState(0);
  useEffect(()=>{
if(defaultValue){
  setCount(defaultValue);
}
  },[defaultValue])
  const incrementCount = () => {
    setCount(count + 1);
    onCounterChange(name, count + 1);
  };
  const decrementCount = () => {
    if (count > 0) {
      setCount(count - 1);
      onCounterChange(name, count - 1);
    }
  };

 

  useEffect(()=>{
    if(count){
      setGuestValue({...guetsValue,[name]:count});
    }
  },[count])

  
  return (
    <>
      <div className="row y-gap-10 justify-between items-center">
        <div className="col-auto">
          <div className="text-15 lh-12 fw-500">{name}</div>
          {name === "Children" && (
            <div className="text-14 lh-12 text-light-1 mt-5">Ages 0 - 17</div>
          )}
        </div>
        {/* End .col-auto */}
        <div className="col-auto">
          <div className="d-flex items-center js-counter">
            <button
              className="button -outline-blue-1 text-blue-1 size-38 rounded-4 js-down"
              onClick={decrementCount}
            >
              <i className="icon-minus text-12" />
            </button>
            {/* decrement button */}
            <div className="flex-center size-20 ml-15 mr-15">
              <div className="text-15 js-count">{count}</div>
            </div>
            {/* counter text  */}
            <button
              className="button -outline-blue-1 text-blue-1 size-38 rounded-4 js-up"
              onClick={incrementCount}
            >
              <i className="icon-plus text-12" />
            </button>
            {/* increment button */}
          </div>
        </div>
        {/* End .col-auto */}
      </div>
      {/* End .row */}
      <div className="border-top-light mt-24 mb-24" />
    </>
  );
};

const GuestSearch = ({ setGuestValue, guetsValue, }) => {
  const [guestCounts, setGuestCounts] = useState({
    Adults: 1,
    Children: 0,
    Rooms: 1,
  });

  const [counters,setCounters]=useState([
    { name: "Adults", defaultValue: 1 },
    { name: "Children", defaultValue: 0 },
    { name: "Rooms", defaultValue: 1 },
  ])
  
  const handleCounterChange = (name, value) => {
    setGuestCounts((prevState) => ({ ...prevState, [name]: value }));
  };
  

  useEffect(() => {
    if(guetsValue){
      const obj={
        Adults: guetsValue.Adults?guetsValue.Adults:1,
        Children: guetsValue.Children?guetsValue.Children:0,
        Rooms: guetsValue.Rooms?guetsValue.Rooms:1,
      }
      const ref=[
        { name: "Adults", defaultValue: guetsValue.Adults },
      { name: "Children", defaultValue: guetsValue.Children },
      { name: "Rooms", defaultValue: guetsValue.Rooms },
      ];
      setCounters(ref);
      setGuestCounts(obj);
    }
  }, [guetsValue]);
  return (
    <div className="searchMenu-guests px-10 lg:py-20  sm:px-20 js-form-dd js-form-counters position-relative">
      <div
        data-bs-toggle="dropdown"
        data-bs-auto-close="outside"
        aria-expanded="false"
        data-bs-offset="0,22"
      >
        <p className="text-12 fw-500 ls-2 lh-16">Guests and Rooms </p>
        <div className="text-15 text-light-1 ls-2 lh-16">
          <span className="js-count-adult">{guestCounts?.Adults}</span> adults -{" "}
          <span className="js-count-child">{guestCounts?.Children}</span> child
          - <span className="js-count-room">{guestCounts?.Rooms}</span> room
        </div>
      </div>
      {/* End guest */}

      <div className="shadow-2 dropdown-menu min-width-400">
        <div className="bg-white px-30 py-30 rounded-4 counter-box">
          {counters.map((counter) => (
            <Counter
              key={counter.name}
              name={counter.name}
              defaultValue={counter.defaultValue}
              onCounterChange={handleCounterChange}
              guetsValue={guetsValue}
              setGuestValue={setGuestValue}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
export default GuestSearch;
